import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";

import Admin from "./components/admin/Admin";
import Browse from "./components/browse/Browse";
import Contribute from "./components/contribute/Contribute";
import DetailedView from "./components/detailed_view/DetailedView";
import Login from "./components/login/Login";
import ProfileSettings from "./components/profile/ProfileSettings";
import PublicProfile from "./components/profile/PublicProfile";
import Signup from "./components/signup/Signup";

import Navigator from "./components/navigator/Navigator";
import { useIsAdmin } from "./hooks/useIsAdmin";
import { useSession } from "./hooks/useSession";

// Guard: only allow admins into /admin
function AdminRoute({ children }) {
    const { session, loading: sessionLoading } = useSession();
    const { isAdmin, loading: adminLoading } = useIsAdmin();

    if (sessionLoading || adminLoading) return null; // or a spinner component

    // Not logged in -> login
    if (!session?.user) return <Navigate to="/login" replace />;

    // Logged in but not admin -> home (or a NotAuthorized page)
    if (!isAdmin) return <Navigate to="/" replace />;

    return children;
}

export default function App() {
    return (
        <div className="App">
            <Navigator />

            <Routes>
                <Route path="/" element={<Browse />} />
                <Route path="/:id" element={<DetailedView />} />
                <Route path="/contribute" element={<Contribute />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/me" element={<ProfileSettings />} />
                <Route path="/u/:username" element={<PublicProfile />} />

                <Route
                    path="/admin"
                    element={
                        <AdminRoute>
                            <Admin />
                        </AdminRoute>
                    }
                />

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
}
